import { RadioValueType } from 'types/componentTypes';

export const genderValues: RadioValueType[] = [
  { key: 'all', value: 0, title: 'All' },
  { key: 'male', value: 1, title: 'Male' },
  { key: 'female', value: 2, title: 'Female' },
]

export default null;
